<template>
  <v-container fluid>
    <h3 class="mb-5">RC Broker užklausos</h3>

    <v-row>
      <v-col cols="12">
        <v-tabs v-model="grupe">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            class="broker-tab"
            v-for="item in grupes"
            :key="`brokergrupe${item.value}`"
          >
            <h4>{{ item.text }}</h4>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <admin-broker-detail :grupe="grupeValue" :key="`brokerdetail${grupe}`" />
  </v-container>
</template>

<script>
import AdminBrokerDetail from './AdminBrokerDetail'

export default {
  name: 'AdminBrokerList',
  components: { AdminBrokerDetail },
  data() {
    return {
      grupe: 0,
    }
  },
  computed: {
    grupes() {
      return [
        {
          text: 'TURTAS aplikacija',
          value: 'darbo-vieta',
        },
        {
          text: 'RC savitarna',
          value: 'savitarna',
        },
      ]
    },
    grupeValue() {
      return this.grupes[this.grupe].value
    },
  },
}
</script>
